// routeKey is the route from the CMS, e.g. :category/:slug/:compare?
// path is the current path, e.g. living-room-furniture/sofas

const isRouteMatchForPath = (routeKey, path) => {
  // If routeKey is an exact match for path, return true
  if (routeKey === path) {
    return true;
  }

  const routeKeySlugs = routeKey.split('/').filter(Boolean);
  const pathSlugs = path.split('/').filter(Boolean);

  return (
    routeKeySlugs.length >= pathSlugs.length &&
    routeKeySlugs.every((routeKeySlug, index) => {
      const pathSlug = pathSlugs[index];
      const isDynamic = routeKeySlug.startsWith(':');
      const isOptional = routeKeySlug.endsWith('?');

      // If the route key slug is an optional dynamic param, return true
      if (isDynamic && isOptional) {
        return true;
      }

      // If the route key slug is a required dynamic param and the path slug is
      // defined, return true
      if (isDynamic && !isOptional && pathSlug) {
        return true;
      }

      // If not a dynamic param, this slug must be an exact match
      return routeKeySlug === pathSlug;
    })
  );
};

export default isRouteMatchForPath;
